// extracted by css-extract-rspack-plugin
export default {"root":"root-FjCzox","searchBar":"searchBar-mvVjaK","searchField":"searchField-k4_Iad","filterContainer":"filterContainer-oZlglK","icon":"icon-D5j8YP"};